module.exports = __webpack_public_path__ + "static/media/404.6a439116.jpg";